var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#57beea",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.026 19.009A2.712 2.712 0 014 16.309a2.712 2.712 0 012.682-2.718c.96-4.41 4.87-7.711 9.546-7.711.873 0 1.72.115 2.525.33A2.7 2.7 0 0121.005 5a2.712 2.712 0 012.705 2.718c0 .469-.118.91-.326 1.294A9.809 9.809 0 0126 15.698a9.811 9.811 0 01-2.904 6.985c.326.448.518 1.001.518 1.599A2.712 2.712 0 0120.908 27a2.707 2.707 0 01-2.519-1.724 9.76 9.76 0 01-2.16.24c-4.241 0-7.851-2.714-9.203-6.507zm.49-.105c1.3 3.568 4.71 6.115 8.712 6.115.695 0 1.372-.077 2.023-.222a2.712 2.712 0 012.657-3.233c.72 0 1.376.283 1.86.744a9.314 9.314 0 002.737-6.61c0-2.41-.91-4.606-2.405-6.26-.496.61-1.25.999-2.095.999a2.712 2.712 0 01-2.706-2.719c0-.374.076-.731.212-1.056a9.253 9.253 0 00-2.283-.284c-4.416 0-8.112 3.101-9.047 7.255a2.715 2.715 0 012.23 2.676 2.718 2.718 0 01-1.896 2.595zm8.712-.484a2.715 2.715 0 01-2.708-2.722c0-1.503 1.212-2.721 2.708-2.721s2.709 1.218 2.709 2.721a2.715 2.715 0 01-2.709 2.722z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIon);
export default __webpack_public_path__ + "static/media/ion.48eb1d7995d26ceade174f4060a55227.svg";
export { ForwardRef as ReactComponent };